import { atom } from 'recoil';

export const personalPromotionsStore = atom({
  key: 'personalPromotionsStore',
  default: {
    items: [],
    loading: false,
    error: null,
    pagination: {
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 0
    },
    filters: {
      status: '',
      paymentType: '',
      dateFrom: '',
      dateTo: '',
      search: ''
    },
    selectedItems: [],
    statistics: {
      totalShows: 0,
      totalActivations: 0,
      totalBonus: 0,
      conversionRate: 0
    }
  },
});

export const personalPromotionsFormModalStore = atom({
  key: 'personalPromotionsFormModalStore',
  default: {
    isOpen: false,
    mode: 'add', // 'add' or 'edit'
    loading: false,
    error: null,
    editingId: null,
    formData: {
      internal_name: '',
      internal_description: '',
      type: 'money',
      status: 'active',
      priority: 0,
      image: '',
      imageFile: null,
      startDate: '',
      endDate: '',
      data: {
        depositThresholds: [
          {
            minDepositAmount: 50000,
            maxDepositAmount: 10000000,
            bonusPercentAmount: 50
          }
        ],
        bonusType: 'all',
        ttlMinutes: 10
      },
      triggerConditions: {
        frequency: [],
        balanceGuard: {},
        dailyUtcWindows: [],
        deposit: {},
        account: {
          requiredSocialAccounts: []
        },
        bet: {}
      }
    }
  },
});
